import { render } from "./AsistenciaList.vue?vue&type=template&id=2f99fa90&scoped=true"
import script from "./AsistenciaList.vue?vue&type=script&lang=js"
export * from "./AsistenciaList.vue?vue&type=script&lang=js"

import "./AsistenciaList.vue?vue&type=style&index=0&id=2f99fa90&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f99fa90"]])

export default __exports__